import driverModel from "./models/driver";
import vehicleModel from "./models/vehicle";

/**
 * Object should have 4 letters key
 * Arrays should have 5 letters key
 * utm is reserved
 */

const initialState = {
    user:{
      type: "group",
      cmrc:{
        type: "hidden",
        middleware: "activateCommercial",
        value: false
      },
      guid:{
        type: "hidden",
        propertyName:"guid",
        value:""
      },
      crmi:{
        type: "hidden",
        value:""
      },
      utmt:{
        type: "hidden",
        value:""
      },
      orig:{
        type: "hidden",
        value:"myinsurancebroker.com"
      },
      clsf:{
        type: "hidden",
        value:"Client"
      },
      add1:{
        type: "hidden",
        value:"69 Pender Crescent"
      },
      prov:{
        type: "hidden",
        value:"ON"
      },
      brkr:{
        type: "hidden",
        middleware: "checkoutVersion",
        value: "MIBF"
      },
      frst:{
        type: "text",
        title: "First Name",
        propertyName:"firstname",
        min:1,
        validators: ["required","minLength"],
        middleware: "crmRecordMiddleware",
        value:""
      },
      last:{
        type: "text",
        title: "Last Name",
        propertyName:"lastname",
        min:1,
        validators: ["required","minLength"],
        middleware: "crmRecordMiddleware",
        value:""
      },
      mail:{
        type: "text",
        title: "Email",
        propertyName:"email",
        validators: ["required","mustBeEmail"],
        middleware: "crmRecordMiddleware",
        value:""
      },
      phne:{
        type: "text",
        title: "Phone",
        propertyName:"phone",
        mask: "+1 (000) 000-0000",
        min: 10,
        validators: ["required","mustBeNumeric","mustBeValidPhone"],
        middleware: "crmRecordMiddleware",
        value:""
      },
      post:{
        type: "text",
        title: "Postal Code",
        propertyName:"zip",
        validators: ["required","mustMatchRegex"],
        regex: /^[A-Za-z]{1}[0-9]{1}[A-Za-z][\s]?[0-9]{1}[A-Za-z]{1}[0-9]{1}$/,
        mask: "a0a 0a0",
        middleware: "postMiddleware",
        value:""
      },
      cmbp:{
        type: "checkbox",
        title: "",
        text: `Yes I want to add a discounts for bundling my Auto and Home polices together`,
        value:"true"
      },
      trms:{
        type: "checkbox",
        title: "",
        text: `I agree to My Insurance Broker's <a href="https://myinsurancebroker.com/about-us/terms-of-service">Terms Of Service</a> and confirm I have reviewed their <a href="https://www.myinsurancebroker.com/about-us/privacy-policy/">Data Use Policy</a></br></br>I agree to receive offers, news and marketing related updates from My Insurance Broker.`,
        validators: ["required"],
        value:""
      },
      loca:{
        type: "hidden",
        value: ""
      },
      loin:{
        type: "hidden",
        value: ""
      },
      mmnb:{
        type: "hidden",
        value:"6202880105769002"
      }
    },
    drivs:{
      type:"object",
      model: driverModel,
      title: `<i class="lni lni-user"></i>Driver(s)`,
      addElement: `<i class="lni lni-user"></i></br>Add Driver`,
      values:[]
    },
    vhcls:{
      type:"object",
      model: vehicleModel,
      title: `<i class="lni lni-car-alt"></i>Vehicle(s)`,
      addElement: `<i class="lni lni-car-alt"></i></br>Add Vehicle`,
      values:[]
    }
};

export default initialState;